module.exports = __webpack_public_path__ + "img/icon-ac.4bf4e540.svg";